import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
  { q: "Como a IA cria o orçamento?", a: "Você descreve o serviço com suas próprias palavras — como faria por mensagem. A IA identifica o cliente, os itens e os valores, calcula os totais e monta o documento no seu modelo. Se faltar algo essencial, ela pergunta antes de finalizar." },
  { q: "Consigo personalizar com a minha marca?", a: "Sim. Você adiciona sua logo, cores, fonte, dados da empresa e escolhe entre 10 modelos A4 premium. Cada empresa que você cria guarda o próprio estilo — ideal para quem atende com marcas diferentes." },
  { q: "Funciona pelo WhatsApp?", a: "Sim, nos planos Standard e Pro. Você conecta seu número uma vez e passa a gerar orçamentos mandando texto ou áudio. O PDF pronto volta na hora, com a sua marca aplicada — e você ainda pode pedir ajustes, trocar de empresa ou reenviar orçamentos antigos por mensagem." },
  { q: "Os PDFs têm qualidade profissional?", a: "Sim. Os orçamentos são exportados em alta resolução, prontos para enviar ao cliente ou imprimir, mantendo o layout A4 fiel ao que você vê na tela." },
  { q: "Serve para o meu nicho?", a: "Serve para praticamente qualquer profissão que emite orçamentos: obras, arquitetura, tecnologia, fotografia, consultoria, eventos, manutenção e muito mais. Você descreve, o Basiq monta." },
  { q: "Meus dados estão seguros?", a: "Seus dados ficam vinculados à sua conta (Google ou e-mail e senha) e não são compartilhados. Cada usuário só acessa as próprias empresas e orçamentos." },
  { q: "Preciso pagar para testar?", a: "Não. O plano Free permite 3 orçamentos por mês, sem cartão. Os planos Standard e Pro têm 7 dias de teste grátis e você cancela quando quiser, direto no app." },
  { q: "Posso ter mais de uma empresa?", a: "Sim. Cada empresa guarda a própria logo, cores, modelo e orçamentos. No WhatsApp, basta dizer qual empresa usar (ex.: \"usa a Mega\")." },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative px-5 py-20 sm:py-28 bg-white border-y border-slate-200/70">
      <div className="max-w-3xl mx-auto">
        <Reveal className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider bg-slate-100 text-slate-600 mb-4">Perguntas frequentes</div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Tudo que você precisa saber</h2>
        </Reveal>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const on = open === i;
            return (
              <Reveal key={i} delay={Math.min(i * 0.04, 0.2)}>
                <div className={`rounded-2xl transition-all ${on ? "bg-slate-50 ring-1 ring-slate-200" : "bg-white ring-1 ring-slate-200 hover:ring-slate-300"}`}>
                  <button onClick={() => setOpen(on ? -1 : i)} data-testid={`faq-${i}`} className="w-full flex items-center justify-between gap-4 text-left px-5 py-4">
                    <span className="text-[15px] font-semibold text-slate-900">{f.q}</span>
                    <span className={`grid place-items-center w-7 h-7 rounded-full shrink-0 transition-all ${on ? "bg-slate-900 text-white rotate-45" : "bg-slate-100 text-slate-500"}`}><Plus size={16} /></span>
                  </button>
                  <AnimatePresence initial={false}>
                    {on && (
                      <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
                        <p className="px-5 pb-5 text-[14px] text-slate-600 leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
